// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/loanbuyinconsts.proto (package aurora.core.consts.contractbuyin, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/loanbuyinconsts.proto.
 */
export const file_consts_loanbuyinconsts: GenFile = /*@__PURE__*/
  fileDesc("Chxjb25zdHMvbG9hbmJ1eWluY29uc3RzLnByb3RvEiBhdXJvcmEuY29yZS5jb25zdHMuY29udHJhY3RidXlpbipPChNDb250cmFjdEJ1eUluU3RhdHVzEg8KC1VOU1BFQ0lGSUVEEAASCwoHUEVORElORxABEgwKCEFDQ0VQVEVEEAISDAoIUkVKRUNURUQQAyq8AQoZQ29udHJhY3RCdXlJblJlamVjdFJlYXNvbhIICgROT05FEAASGwoXT1VUU0lERV9TVVBQT1JURURfSE9VUlMQARIfChtVTlNVUFBPUlRFRF9NRVNTQUdFX0RFVEFJTFMQAhIgChxVTktOT1dOX0VYRUNJRF9OT1RfWU9VUl9MT0FOEAMSEwoPTE9BTl9JTkVMSUdJQkxFEAQSFQoRSU5WQUxJRF9CVVlJTl9RVFkQBRIJCgVPVEhFUhAGQilaJ2dpdGxhYi5wcnZibC5jb20vYXVyb3JhL2NvcmUvc3JjL2NvbnN0c2IGcHJvdG8z");

/**
 * ContractBuyInStatus : the state a Buy-In is in now
 *
 * @generated from enum aurora.core.consts.contractbuyin.ContractBuyInStatus
 */
export enum ContractBuyInStatus {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: REJECTED = 3;
   */
  REJECTED = 3,
}

/**
 * Describes the enum aurora.core.consts.contractbuyin.ContractBuyInStatus.
 */
export const ContractBuyInStatusSchema: GenEnum<ContractBuyInStatus> = /*@__PURE__*/
  enumDesc(file_consts_loanbuyinconsts, 0);

/**
 * @generated from enum aurora.core.consts.contractbuyin.ContractBuyInRejectReason
 */
export enum ContractBuyInRejectReason {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: OUTSIDE_SUPPORTED_HOURS = 1;
   */
  OUTSIDE_SUPPORTED_HOURS = 1,

  /**
   * @generated from enum value: UNSUPPORTED_MESSAGE_DETAILS = 2;
   */
  UNSUPPORTED_MESSAGE_DETAILS = 2,

  /**
   * @generated from enum value: UNKNOWN_EXECID_NOT_YOUR_LOAN = 3;
   */
  UNKNOWN_EXECID_NOT_YOUR_LOAN = 3,

  /**
   * @generated from enum value: LOAN_INELIGIBLE = 4;
   */
  LOAN_INELIGIBLE = 4,

  /**
   * @generated from enum value: INVALID_BUYIN_QTY = 5;
   */
  INVALID_BUYIN_QTY = 5,

  /**
   * @generated from enum value: OTHER = 6;
   */
  OTHER = 6,
}

/**
 * Describes the enum aurora.core.consts.contractbuyin.ContractBuyInRejectReason.
 */
export const ContractBuyInRejectReasonSchema: GenEnum<ContractBuyInRejectReason> = /*@__PURE__*/
  enumDesc(file_consts_loanbuyinconsts, 1);

